export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./delete-contact.vue?vue&type=template&id=759f9d3d&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/modals/delete-contact.vue?vue&type=template&id=759f9d3d&
// module id = 1398
// module chunks = 0